import { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export const BulkBar = ({ sel, setSel, pages, reload }) => {
  const [model, setModel] = useState("claude");
  const [busy, setBusy] = useState(false);
  const overlapping = pages.filter(p => p.overlaps.some(o => o.type === "content")).map(p => p.slug);
  const run = async () => {
    if (!window.confirm(`Rewrite ${sel.length} page(s) with AI? Each becomes a draft for you to approve — nothing is published.`)) return;
    setBusy(true);
    try { const { data } = await api.post("/api/seo/admin/bulk-ai", { slugs: sel, model }); toast.success(`AI is rewriting ${data.started.length} page(s) — they'll appear as drafts awaiting approval`); setSel([]); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 bg-violet-50 border border-violet-200 rounded-2xl p-3" data-testid="bulk-bar">
      <Sparkles className="w-4 h-4 text-violet-700" /><span className="text-sm font-semibold text-violet-900">Bulk AI rewrite</span>
      <button onClick={() => setSel(overlapping)} className="h-8 px-3 rounded-full border border-violet-300 text-xs font-bold text-violet-800" data-testid="bulk-select-similar">Select all similar-text pages ({overlapping.length})</button>
      {sel.length > 0 && <button onClick={() => setSel([])} className="text-xs text-slate-500 underline" data-testid="bulk-clear">Clear</button>}
      <span className="flex-1" />
      <select value={model} onChange={e => setModel(e.target.value)} className="h-8 border rounded-lg px-2 text-xs" data-testid="bulk-model"><option value="claude">Claude Sonnet</option><option value="gpt">GPT</option></select>
      <button disabled={!sel.length || busy} onClick={run} className="h-8 px-4 rounded-full bg-violet-700 text-white text-xs font-bold disabled:opacity-40" data-testid="bulk-run">Rewrite {sel.length} selected</button>
    </div>
  );
};
